module.exports = __webpack_public_path__ + "img/easy_setup.2169385a.svg";